var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.581,
    height: 25.535,
    viewBox: "0 0 11.581 25.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M131.5,231.3h0v-6.143h5.529V231.3h4.761v4.479h-4.761v7.462a2.31,2.31,0,0,0,2.534,2.611c.883,0,3.517.023,3.517.023v4.816H138.64c-4.108,0-7.141-2.572-7.141-7.142v-8.025h0Z",
    transform: "translate(-131.498 -225.158)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.cd5e2d5821fa665a3fb5677126218b05.svg";
export { ForwardRef as ReactComponent };